import { useSwitcher } from 'shared/hooks'

import { useCurrentId } from '../../hooks'
import { MessageActions } from '../MessageActions'
import { MessageForm } from '../MessageForm/MessageForm'
import css from './Chat.module.scss'
import { Conversation } from './Conversation'

export function Chat() {
	const conversation = useCurrentId()

	const expand = useSwitcher(false)

	return conversation ? (
		<>
			<Conversation
				className={expand.isOn ? css.shrinkChat : undefined}
				key={conversation}
			/>

			<MessageForm isExpand={expand.isOn} toggleExpand={expand.toggle} />
			<MessageActions />
		</>
	) : null
}
